import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * The stock shadcn input, at the app's own control height.
 *
 * 40px RATHER THAN shadcn's 36, because every other control in this product is 40 —
 * the search fields, the join button, the icon actions (`TOP_ROW_ACTION`) — and a
 * form field a notch shorter than everything around it reads as a different app's
 * widget. It is also the smallest comfortable thumb target.
 *
 * THE `file:` VARIANTS ARE DELIBERATELY NOT HERE. Upstream's input carries a row of
 * them for `type="file"`, and this product has no file input anywhere by rule — a
 * profile photograph is captured, never chosen (docs/5 § D260804-2359, and see
 * `CaptureAvatar`). Styling for a control that may not exist is an invitation to add
 * one.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full min-w-0 rounded-lg border border-input bg-transparent px-3 py-1 text-[15px] shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
}

export { Input }
